import React, { useMemo } from "react";
import { Colors } from "../../../../utils/colors";
import { HorizontalDivider } from "../../../Dividers/HorizontalDivider";
import LargePopupModalContainer from "../../../Containers/LargePopupModalContainer";
import LargePopupModalHeader from "../../../Containers/LargePopupModalHeader";
import { formatPhoneNumber } from "../../../../utils/FormatPhoneNumber";

type ValidContactsPopupPanelProps = {
  contactsToShow: { name: string; phoneNumber: string }[];
  contactsView: number;
  setContactsView: (contactsView: number) => void;
};

const ValidContactsPopupPanel = (props: ValidContactsPopupPanelProps) => {
  const { contactsToShow, contactsView, setContactsView } = props;

  const styles = {
    itemTitle: { fontSize: 14, fontWeight: 500 },
    itemSubtext: { fontSize: 12, color: Colors.GRAY1 },
  };

  const contactsTitle = useMemo(
    () =>
      contactsView === 1
        ? "Valid Contacts"
        : contactsView === 2
        ? "Failed Contacts"
        : contactsView === 3
        ? "Duplicate Contacts"
        : "Already Existing Contacts",
    [contactsView]
  );

  return (
    <LargePopupModalContainer
      showModal={contactsView > 0}
      headerComp={
        <LargePopupModalHeader
          title={contactsTitle}
          backOnPress={() => setContactsView(0)}
        />
      }
      valueComp={
        <div
          className="HideScrollbar"
          style={{ overflow: "auto", height: "calc(100vh - 110px)" }}
        >
          {contactsToShow.map((contact) => (
            <div className="ColumnNormal" key={contact.phoneNumber}>
              <div className="ColumnNormal" style={{ gap: 4 }}>
                <span style={styles.itemTitle}>
                  {contact.name ? contact.name : "Unassigned Name"}
                </span>
                <span style={styles.itemSubtext}>
                  {contact.phoneNumber !== ""
                    ? formatPhoneNumber(contact.phoneNumber)
                    : "No Number Found"}
                </span>
              </div>
              <HorizontalDivider altMargin={14} />
            </div>
          ))}
        </div>
      }
    />
  );
};

export default ValidContactsPopupPanel;
